(function () {
  "use strict";

  var QUERY = {
    need: {
      sack_machine: "masina de cusut saci",
      sack_thread: "ata pentru cusut saci 12/4",
      sack_part: "piesa de schimb pentru masina de cusut saci",
      industrial_part: "piesa de schimb pentru masina de cusut industriala",
      ironing: "articol profesional pentru calcat",
      accessory: "accesoriu consumabil pentru atelier de croitorie",
      guidance: "produs tehnic pentru atelier sau inchiderea sacilor",
    },
    workMode: {
      machine_portable_220: "portabila la 220 V",
      machine_battery: "portabila cu acumulator fara cablu",
      machine_fixed: "pentru linie fixa sau pneumatica de productie",
      thread_200g: "con 200 g",
      thread_1_3kg: "con 1 kg 2 kg sau 3 kg",
      thread_5kg: "con 5 kg",
      thread_bulk: "pachet 50 sau 100 conuri",
      sack_needle: "ac ace",
      sack_belt: "curea",
      sack_looper_knife: "graifer cutit placa",
      sack_motor_electric: "motor intrerupator componenta electrica",
      sack_other: "componenta piesa de schimb",
      industrial_linear: "pentru masina liniara",
      industrial_overlock: "pentru masina de surfilat overlock",
      industrial_coverstitch: "pentru uberdeck coverstitch acoperire",
      industrial_transport: "pentru dublu sau triplu transport",
      industrial_special: "pentru butoniera cheite sau nasturi",
      industrial_cutting: "pentru masina de croit",
      industrial_other: "pentru masina de cusut industriala",
      ironing_equipment: "fier generator sau masa de calcat completa",
      ironing_consumable: "consumabil accesoriu talpa husa pasla furtun suport",
      ironing_spare: "piesa termostat rezistenta pompa presostat electrovalva",
      accessory_cutting_marking: "foarfeca creta marker ruleta croitorie",
      accessory_needle: "ace pentru masina de cusut industriala",
      accessory_maintenance: "ulei spray perie pompa intretinere",
      accessory_labeling: "pistol etichetare ace si consumabile",
      accessory_cutting_machine: "lama abraziv consumabil pentru masina de croit",
      guidance_sacks: "pentru inchiderea sacilor",
      guidance_industrial: "pentru repararea unei masini de cusut industriale",
      guidance_ironing: "pentru calcat profesional",
      guidance_workshop: "pentru echiparea atelierului",
      guidance_unsure: "cu recomandare dupa utilizare",
    },
    volume: {
      occasional: "pentru utilizare ocazionala si volum mic",
      up_to_300: "pentru pana la 300 de saci pe zi",
      "300_1000": "pentru 300 pana la 1000 de saci pe zi",
      over_1000: "pentru peste 1000 de saci pe zi si productie mare",
      thread_occasional: "pentru consum ocazional",
      thread_weekly: "pentru consum saptamanal",
      thread_daily: "pentru consum zilnic",
      thread_bulk_use: "pentru aprovizionare in volum",
      code_exact: "cu codul exact al piesei",
      model_exact: "cu modelul complet al utilajului",
      brand_only: "dupa marca sau familia utilajului",
      use_occasional: "pentru utilizare ocazionala",
      use_daily: "pentru utilizare zilnica",
      use_workshop: "pentru atelier",
      use_production: "pentru productie intensiva",
      use_bulk: "in cantitate mare",
      priority_compatibility: "cu prioritate pentru compatibilitate",
      priority_price: "cu prioritate pentru pret",
      priority_available: "disponibil acum",
      priority_specialist: "pentru verificare de specialist",
      unknown: "",
    },
    model: {
      gk9: "compatibil cu GK-9-12",
      gk26: "compatibil cu GK 26-1A",
      n600_f300: "compatibil cu N600A sau F300A",
      fixed: "compatibil cu N980A F900AC Fischbein sau Newlong",
      material_rafia: "pentru saci din rafie polipropilena",
      material_paper: "pentru saci din hartie",
      material_textile: "pentru saci textili sau iuta",
      material_unknown: "",
      thread_portable: "pentru masina portabila de cusut saci",
      thread_fixed: "pentru linie fixa de cusut saci",
      thread_unknown: "",
      model_other: "",
      brand_juki: "compatibil Juki",
      brand_brother: "compatibil Brother",
      brand_pegasus: "compatibil Pegasus",
      brand_maqi: "compatibil Maqi",
      brand_pfaff: "compatibil Pfaff",
      brand_other: "",
      equipment_iron: "pentru fier de calcat",
      equipment_generator: "pentru generator de abur",
      equipment_table: "pentru masa de calcat",
      equipment_steam: "pentru instalatie de abur",
      equipment_other: "",
      compat_exact: "compatibil cu modelul exact",
      compat_system: "dupa sistem sau cod",
      compat_none: "fara compatibilitate cu utilaj",
      compat_unknown: "",
      info_exact_model: "dupa modelul exact",
      info_part_code: "dupa codul piesei",
      info_photo: "identificare dupa fotografie",
      info_none: "",
    },
  };

  var BUDGET = {
    under_100: { min: null, max: 10000, label: "sub 100 lei" },
    "100_800": { min: 10000, max: 80000, label: "100–800 lei" },
    "800_2500": { min: 80000, max: 250000, label: "800–2.500 lei" },
    over_2500: { min: 250000, max: null, label: "peste 2.500 lei" },
    flexible: { min: null, max: null, label: "buget flexibil" },
  };

  var MODEL_MATCH = {
    gk9: /gk[\s-]?9(?:[\s-]?12)?/,
    gk26: /gk[\s-]?26(?:[\s-]?1a)?/,
    n600_f300: /n600a?|f300a?/,
    fixed: /n980a?|f900ac|fischbein|newlong/,
    brand_juki: /\bjuki\b/,
    brand_brother: /\bbrother\b/,
    brand_pegasus: /\bpegasus\b/,
    brand_maqi: /\bmaqi\b/,
    brand_pfaff: /\bpfaff\b/,
    equipment_iron: /fier(?: de)? calcat|talpa.*fier|maner.*fier/,
    equipment_generator: /generator|vaporino|boiler/,
    equipment_table: /masa de calcat|husa.*masa|pasla.*masa|antena.*masa/,
    equipment_steam: /abur|electrovalva|presostat|rezistenta|termostat|pompa/,
  };

  var STEP_COPY = {
    sack_machine: [
      null,
      ["Tipul mașinii", "Cum trebuie instalată mașina?", "Separăm soluțiile portabile de liniile fixe."],
      ["Materialul sacilor", "Ce tip de saci vei coase?", "Materialul poate influența configurația și consumabilele."],
      ["Volumul de lucru", "Câți saci închizi aproximativ?", "Volumul separă utilizarea portabilă de producția intensivă."],
    ],
    sack_thread: [
      null,
      ["Formatul aței", "Ce format de ață cauți?", "Alege cantitatea pe care vrei să o cumperi."],
      ["Tipul mașinii", "Pe ce tip de mașină folosești ața?", "Nu presupunem un model dacă nu îl cunoști."],
      ["Ritmul de consum", "Cât de des consumi ață?", "Folosim ritmul doar pentru a ordona formatele potrivite."],
    ],
    sack_part: [
      null,
      ["Tipul piesei", "Ce piesă cauți?", "Pornim de la componentă, apoi verificăm modelul."],
      ["Modelul mașinii", "Pentru ce model este piesa?", "Păstrăm doar rezultatele în care catalogul confirmă familia selectată."],
      ["Identificarea piesei", "Cât de exact poți identifica piesa?", "Codul sau modelul complet reduce riscul de incompatibilitate."],
    ],
    industrial_part: [
      null,
      ["Tipul utilajului", "Pentru ce tip de mașină industrială cauți piesa?", "Tipul utilajului este mai important decât bugetul."],
      ["Marca utilajului", "Care este marca mașinii?", "Modelul complet poate fi introdus la ultimul pas."],
      ["Identificarea piesei", "Cât de exact poți identifica piesa?", "Nu recomandăm compatibilitate dacă modelul sau codul nu o confirmă."],
    ],
    ironing: [
      null,
      ["Tipul produsului", "Ce cauți pentru călcat?", "Separăm echipamentele complete de consumabile și piese."],
      ["Echipamentul", "Pentru ce echipament este produsul?", "Tipul echipamentului ajută la compatibilitate."],
      ["Nivelul de utilizare", "Cât de intens va fi folosit?", "Diferențiem utilizarea ocazională de atelier și producție."],
    ],
    accessory: [
      null,
      ["Utilizarea", "Ce fel de accesoriu sau consumabil cauți?", "Alegerea evită amestecarea foarfecilor, acelor și produselor de întreținere."],
      ["Compatibilitatea", "Produsul trebuie să fie compatibil cu un utilaj?", "Pentru ace și lame, sistemul sau modelul exact contează."],
      ["Necesarul", "Pentru ce nivel de utilizare cumperi?", "Cantitatea și utilizarea ajută la ordonarea rezultatelor."],
    ],
    guidance: [
      null,
      ["Obiectivul", "Ce vrei să rezolvi?", "Pornim de la problemă dacă nu știi denumirea produsului."],
      ["Informațiile disponibile", "Ce informații ai acum?", "Un model, un cod sau o fotografie ajută la identificare."],
      ["Prioritatea", "Ce este cel mai important pentru tine?", "Dacă nu există o potrivire confirmată, te trimitem către specialist."],
    ],
  };

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  function stripHtml(html) {
    var doc = new DOMParser().parseFromString(String(html || ""), "text/html");
    return doc.body.textContent || "";
  }

  function cleanExtra(value) {
    return String(value || "")
      .replace(/[\u0000-\u001f\u007f]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 120);
  }

  function amount(value) {
    if (!value || typeof value.amount !== "number") return null;
    return value.amount;
  }

  function money(minor, currency) {
    return new Intl.NumberFormat("ro-RO", {
      style: "currency",
      currency: currency || "RON",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(Number(minor || 0) / 100);
  }

  function productText(product) {
    var collections = (product.collections || [])
      .map(function (collection) {
        return collection.title || collection.handle || "";
      })
      .join(" ");
    return normalize(
      [
        product.title,
        product.product_type,
        product.type,
        product.vendor,
        stripHtml(product.description && product.description.html),
        (product.tags || []).join(" "),
        collections,
      ].join(" "),
    );
  }

  function availableVariant(product) {
    return (product.variants || []).find(function (variant) {
      return variant.availability && variant.availability.available;
    });
  }

  function collectionText(product) {
    return normalize(
      (product.collections || [])
        .map(function (collection) {
          return [collection.handle, collection.title].filter(Boolean).join(" ");
        })
        .join(" "),
    );
  }

  function productKind(product, text) {
    var title = normalize(product.title);
    var type = normalize(product.product_type || product.type);
    var collections = collectionText(product);
    var isSackThread =
      /ata-pentru-cusut-saci|ata pentru cusut saci/.test(collections) ||
      /ata (?:de |pentru )?cusut saci/.test(title) ||
      /ata pentru cusut saci/.test(type);
    var isSackPart = /piese?-de-schimb.*(?:cusut-)?saci|piese? de schimb.*cusut saci/.test(collections);
    var isSackMachine =
      /masina de cusut saci/.test(type) ||
      /^masina (?:de |pentru )?cusut saci/.test(title);
    var isIroning =
      /articole-pentru-calcat|articole pentru calcat/.test(collections) ||
      /\b(fier de calcat|generator de abur|masa de calcat|talpa teflon|husa masa|pasla masa|presostat|electrovalva)\b/.test(title);
    var isIndustrialPart =
      /piese?-de-schimb|piese? de schimb/.test(collections) ||
      /\b(piciorus|graifer|cutit|placa de ac|transportor|croseta|suveica|ghidaj|tensiometru)\b/.test(title);
    var isAccessory = /\baccesorii\b/.test(collections);
    if (isSackThread) return "sack_thread";
    if (isSackPart) return "sack_part";
    if (isSackMachine) return "sack_machine";
    if (isIroning) return "ironing";
    if (isIndustrialPart) return "industrial_part";
    if (isAccessory) return "accessory";
    if (/cusut saci|gk[\s-]?(?:9|26)|n600|f300|n980|f900|fischbein|newlong/.test(text)) return "sack_related";
    return "other";
  }

  function matchesNeed(product, need, text) {
    var kind = productKind(product, text);
    var collections = collectionText(product);
    if (need === "accessory") {
      return /\baccesorii\b/.test(collections) && !/^(sack_|ironing)/.test(kind);
    }
    if (need === "ironing") return kind === "ironing" || /articole-pentru-calcat|articole pentru calcat/.test(collections);
    if (need === "guidance") return kind !== "other";
    if (need === "sack_machine") return kind === "sack_machine";
    if (need === "sack_thread") return kind === "sack_thread";
    if (need === "sack_part") return kind === "sack_part";
    if (need === "industrial_part") return kind === "industrial_part";
    return false;
  }

  function workModeMatch(text, answers) {
    if (answers.work_mode === "machine_battery") return /acumulator|baterie|12v|fara cablu/.test(text);
    if (answers.work_mode === "machine_portable_220") {
      return /portabil/.test(text) && !/acumulator|baterie|12v|fara cablu/.test(text);
    }
    if (answers.work_mode === "machine_fixed") {
      return /fixa|fix|pneumatic|linie|automat|n980|f900/.test(text);
    }
    if (answers.work_mode === "thread_200g") return /(?:^|\D)200\s*g(?:\D|$)/.test(text);
    if (answers.work_mode === "thread_1_3kg") return /(?:1|2|3)\s*kg/.test(text);
    if (answers.work_mode === "thread_5kg") return /5\s*kg/.test(text);
    if (answers.work_mode === "thread_bulk") return /(?:50|100)\s*(?:con|buc)|cutie/.test(text);
    if (answers.work_mode === "sack_needle") return /\b(?:ac|ace)\b/.test(text);
    if (answers.work_mode === "sack_belt") return /\bcurea\b/.test(text);
    if (answers.work_mode === "sack_looper_knife") return /graifer|cutit|placa|croseta/.test(text);
    if (answers.work_mode === "sack_motor_electric") return /motor|intrerupator|electric|cablu|perie|carbune/.test(text);
    if (answers.work_mode === "industrial_linear") return /liniar|ddl|dln|dmn|lockstitch/.test(text);
    if (answers.work_mode === "industrial_overlock") return /surfil|overlock|mo-|b27|dcx27/.test(text);
    if (answers.work_mode === "industrial_coverstitch") return /uberdeck|coverstitch|acoperire|mf-|w500|u600/.test(text);
    if (answers.work_mode === "industrial_transport") return /dublu transport|triplu transport|walking foot|lu-|ls-/.test(text);
    if (answers.work_mode === "industrial_special") return /butonier|cheit|nastur|bartack|buttonhole/.test(text);
    if (answers.work_mode === "industrial_cutting") return /croit|eastman|cutting|lama/.test(text);
    if (answers.work_mode === "ironing_equipment") return /fier de calcat|generator|masa de calcat|vaporino|tulipano/.test(text);
    if (answers.work_mode === "ironing_consumable") return /talpa|husa|pasla|furtun|suport|garnitura|capac|dop|antena/.test(text);
    if (answers.work_mode === "ironing_spare") return /termostat|rezistenta|pompa|presostat|electrovalva|turbina|regulator|intrerupator|valva/.test(text);
    if (answers.work_mode === "accessory_cutting_marking") return /foarfec|creta|marker|creion|ruleta|penseta/.test(text);
    if (answers.work_mode === "accessory_needle") return /\b(?:ac|ace)\b|dbx1|dpx5|b27|dcx27|uyx/.test(text);
    if (answers.work_mode === "accessory_maintenance") return /ulei|spray|lubrif|perie|pompa/.test(text);
    if (answers.work_mode === "accessory_labeling") return /etichet|pistol|pin/.test(text);
    if (answers.work_mode === "accessory_cutting_machine") return /croit|eastman|lama|abraziv/.test(text);
    return true;
  }

  function modelMatch(text, answers) {
    var matcher = MODEL_MATCH[answers.model];
    if (!matcher) return true;
    if (answers.need === "sack_part" || answers.need === "industrial_part" || answers.need === "ironing") {
      return matcher.test(text);
    }
    return true;
  }

  function volumeFit(text, answers, kind) {
    if (answers.volume === "over_1000") {
      if (kind === "sack_machine") return /fixa|fix|pneumatic|linie|automat|n980|f900/.test(text);
    }
    if ((answers.volume === "occasional" || answers.volume === "up_to_300") && kind === "sack_machine") {
      return /portabil/.test(text);
    }
    if (answers.volume === "thread_bulk_use" && kind === "sack_thread") {
      return /5\s*kg|(?:50|100)\s*(?:con|buc)|cutie/.test(text);
    }
    return true;
  }

  function guidanceMatch(kind, answers) {
    if (answers.need !== "guidance") return true;
    if (answers.work_mode === "guidance_sacks") return /^sack_/.test(kind);
    if (answers.work_mode === "guidance_industrial") return kind === "industrial_part";
    if (answers.work_mode === "guidance_ironing") return kind === "ironing";
    if (answers.work_mode === "guidance_workshop") return kind === "accessory" || kind === "industrial_part";
    return kind !== "other";
  }

  function extraMatch(text, answers) {
    if (answers.volume !== "code_exact" && answers.volume !== "model_exact") return true;
    var words = normalize(answers.extra).split(/[^a-z0-9]+/).filter(function (word) {
      return word.length > 2;
    });
    if (!words.length) return false;
    return words.some(function (word) {
      return text.indexOf(word) !== -1;
    });
  }

  function assessProduct(product, answers) {
    var text = productText(product);
    var variant = availableVariant(product);
    var price = amount(product.price_range && product.price_range.min);
    var budget = BUDGET[answers.budget] || BUDGET.flexible;
    var kind = productKind(product, text);
    var modelMatcher = MODEL_MATCH[answers.model];

    if (!variant || price === null) return null;
    if (text.indexOf("resigilat") !== -1 && normalize(answers.extra).indexOf("resigilat") === -1) return null;
    if (budget.min !== null && price < budget.min) return null;
    if (budget.max !== null && price > budget.max) return null;
    if (!matchesNeed(product, answers.need, text)) return null;
    if (!guidanceMatch(kind, answers)) return null;
    if (!workModeMatch(text, answers)) return null;
    if (!modelMatch(text, answers)) return null;
    if (!volumeFit(text, answers, kind)) return null;
    if (!extraMatch(text, answers)) return null;

    var score = 10;
    var reasons = [];

    reasons.push("Preț actual în bugetul ales: " + money(price, product.price_range.min.currency));

    if (answers.need === "sack_machine") reasons.push("Catalogul îl clasifică drept mașină pentru cusut saci");
    if (answers.need === "sack_thread") reasons.push("Catalogul confirmă ață pentru cusut saci");
    if (answers.need === "sack_part") reasons.push("Catalogul confirmă o piesă pentru mașini de cusut saci");
    if (answers.need === "industrial_part") reasons.push("Catalogul confirmă o piesă pentru mașini de cusut industriale");
    if (answers.need === "ironing") reasons.push("Produsul aparține categoriei articole pentru călcat");
    if (answers.need === "accessory") reasons.push("Produsul aparține categoriei accesorii și consumabile");

    if (answers.work_mode === "machine_battery") {
      reasons.push("Descrierea confirmă alimentarea cu acumulator");
      score += 5;
    } else if (answers.work_mode === "machine_portable_220" && kind === "sack_machine") {
      reasons.push("Descrierea confirmă formatul portabil cu alimentare la rețea");
      score += 3;
    } else if (answers.work_mode === "machine_fixed" && kind === "sack_machine") {
      reasons.push("Descrierea îl poziționează pentru linie fixă sau producție");
      score += 4;
    } else if (workModeMatch(text, answers)) {
      reasons.push("Denumirea sau descrierea confirmă tipul selectat");
      score += 3;
    }

    if (modelMatcher && modelMatcher.test(text)) {
      reasons.push("Descrierea confirmă compatibilitatea cu modelul selectat");
      score += 5;
    }

    if (answers.volume === "over_1000" && volumeFit(text, answers, kind)) {
      reasons.push("Format potrivit pentru consum sau producție mare");
      score += 4;
    } else if ((answers.volume === "occasional" || answers.volume === "up_to_300") && kind === "sack_machine") {
      reasons.push("Format portabil potrivit pentru volum mic sau mediu");
      score += 2;
    }

    if (reasons.length < 3) reasons.push("Este disponibil acum în catalogul Cusut-Surfilat.ro");

    return {
      product: product,
      variant: variant,
      price: price,
      score: score,
      reasons: reasons.slice(0, 3),
    };
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function appendHidden(form, name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function track(eventName, properties) {
    var payload = Object.assign({ event: eventName, feature_name: "citera_assist" }, properties || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      var shopifyEventName = eventName.replace(/^citera_assist_/, "citera_assist:");
      try {
        var publication = window.Shopify.analytics.publish(shopifyEventName, payload);
        if (publication && typeof publication.catch === "function") publication.catch(function () {});
      } catch (error) {}
    }

    document.dispatchEvent(new CustomEvent("citera:assist", { detail: payload }));
  }

  function secureProfileUrl(value) {
    var profile = String(value || "").trim();
    if (profile.indexOf("//") === 0) profile = "https:" + profile;
    try {
      profile = new URL(profile, window.location.href).href;
    } catch (error) {
      return "";
    }
    return profile.indexOf("https://") === 0 ? profile : "";
  }

  function markCartAssisted(sessionId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        attributes: {
          "Citera Assist": "Da",
          "Citera Assist sesiune": sessionId,
        },
      }),
      keepalive: true,
    }).catch(function () {});
  }

  function init(root) {
    if (root.dataset.assistReady === "true") return;
    root.dataset.assistReady = "true";

    var dialog = root.querySelector("[data-assist-dialog]");
    var form = root.querySelector("[data-assist-form]");
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-assist-step]"));
    var openButton = root.querySelector("[data-assist-open]");
    var closeButton = root.querySelector("[data-assist-close]");
    var backButton = root.querySelector("[data-assist-back]");
    var nextButton = root.querySelector("[data-assist-next]");
    var submitButton = root.querySelector("[data-assist-submit]");
    var progressWrap = root.querySelector("[data-assist-progress-wrap]");
    var progress = root.querySelector("[data-assist-progress]");
    var progressLabel = root.querySelector("[data-assist-progress-label]");
    var progressName = root.querySelector("[data-assist-progress-name]");
    var loading = root.querySelector("[data-assist-loading]");
    var results = root.querySelector("[data-assist-results]");
    var resultGrid = root.querySelector("[data-assist-result-grid]");
    var resultsTitle = root.querySelector("[data-assist-results-title]");
    var empty = root.querySelector("[data-assist-empty]");
    var emptyCopy = root.querySelector("[data-assist-empty-copy]");
    var standardSearch = root.querySelector("[data-assist-search-link]");
    var panel = root.querySelector(".citera-assist__panel");
    var extraInput = form.querySelector('input[name="extra"]');
    var extraLabel = root.querySelector("[data-assist-extra-label]");
    var currentStep = 0;
    var sessionId = "ca_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
    var lastInvoker = null;

    if (!dialog || !form || !steps.length) return;

    function selectedOnStep(index) {
      return Boolean(steps[index].querySelector("input[type='radio']:checked:not(:disabled)"));
    }

    function selectedNeed() {
      var input = form.querySelector('input[name="need"]:checked');
      return input ? input.value : "";
    }

    function applyBranch() {
      var need = selectedNeed();
      root.querySelectorAll("[data-assist-needs]").forEach(function (option) {
        var allowed = (option.getAttribute("data-assist-needs") || "").split(/\s+/).indexOf(need) !== -1;
        var input = option.querySelector("input");
        option.hidden = !allowed;
        if (input) {
          input.disabled = !allowed;
          if (!allowed) input.checked = false;
        }
      });

      var copy = STEP_COPY[need];
      if (copy) {
        [1, 2, 3].forEach(function (index) {
          var stepCopy = copy[index];
          if (!stepCopy) return;
          steps[index].setAttribute("data-step-name", stepCopy[0]);
          var legend = steps[index].querySelector("[data-assist-branch-legend]");
          var hint = steps[index].querySelector("[data-assist-branch-hint]");
          if (legend) legend.textContent = stepCopy[1];
          if (hint) hint.textContent = stepCopy[2];
        });
      }

      if (extraInput && extraLabel) {
        extraInput.setCustomValidity("");
        if (need === "sack_part" || need === "industrial_part") {
          extraLabel.textContent = "Codul piesei sau modelul complet al mașinii (recomandat)";
          extraInput.placeholder = "Ex.: 170XL, GK-9-12/B, Juki DDL-8700, cod ștanțat pe piesă";
        } else if (need === "ironing") {
          extraLabel.textContent = "Marca, modelul echipamentului sau altă condiție (opțional)";
          extraInput.placeholder = "Ex.: generator Vaporino, masă de 120 cm, cod termostat";
        } else if (need === "accessory") {
          extraLabel.textContent = "Sistemul, codul sau cantitatea dorită (opțional)";
          extraInput.placeholder = "Ex.: DBx1 nr. 90, 10 bucăți, foarfecă 10 inch";
        } else if (need === "sack_thread") {
          extraLabel.textContent = "Cantitatea sau altă condiție (opțional)";
          extraInput.placeholder = "Ex.: 5 kg, pachet 50 conuri, utilizare zilnică";
        } else {
          extraLabel.textContent = "Model exact, material sau altă condiție (opțional)";
          extraInput.placeholder = "Ex.: GK-9-12/B, saci din rafie, lucru fără cablu";
        }
      }
    }

    function updateStep() {
      applyBranch();
      steps.forEach(function (step, index) {
        step.hidden = index !== currentStep;
      });
      progress.value = currentStep + 1;
      progress.textContent = currentStep + 1 + " din " + steps.length;
      progress.setAttribute("aria-valuetext", "Pasul " + (currentStep + 1) + " din " + steps.length);
      progressLabel.textContent = "Pasul " + (currentStep + 1) + " din " + steps.length;
      progressName.textContent = steps[currentStep].getAttribute("data-step-name") || "";
      backButton.hidden = currentStep === 0;
      nextButton.hidden = currentStep === steps.length - 1;
      submitButton.hidden = currentStep !== steps.length - 1;
      nextButton.disabled = !selectedOnStep(currentStep);
      submitButton.disabled = !selectedOnStep(currentStep);
      var legend = steps[currentStep].querySelector("legend");
      if (legend) legend.focus && legend.focus();
    }

    function openDialog() {
      lastInvoker = document.activeElement;
      var preselectedNeed = openButton.getAttribute("data-assist-goal") || "";
      var preselectedInput = preselectedNeed
        ? form.querySelector('input[name="need"][value="' + preselectedNeed + '"]')
        : null;
      if (preselectedInput) {
        form.querySelectorAll('input[name="need"]').forEach(function (input) {
          input.checked = input === preselectedInput;
        });
        currentStep = 0;
        applyBranch();
        updateStep();
      }
      try {
        dialog.showModal();
      } catch (error) {
        dialog.setAttribute("open", "");
      }
      document.documentElement.style.overflow = "hidden";
      closeButton.focus();
      var placement = openButton.getAttribute("data-assist-placement") || "homepage_section";
      var sourceProductId = openButton.getAttribute("data-assist-product-id") || undefined;
      var sourceProductHandle = openButton.getAttribute("data-assist-product-handle") || undefined;
      openButton.removeAttribute("data-assist-placement");
      openButton.removeAttribute("data-assist-goal");
      openButton.removeAttribute("data-assist-product-id");
      openButton.removeAttribute("data-assist-product-handle");
      track("citera_assist_opened", {
        assist_session_id: sessionId,
        placement: placement,
        preselected_need: preselectedNeed || undefined,
        source_product_id: sourceProductId,
        source_product_handle: sourceProductHandle,
      });
    }

    function closeDialog() {
      if (dialog.open && typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      document.documentElement.style.overflow = "";
      if (lastInvoker && typeof lastInvoker.focus === "function") lastInvoker.focus();
    }

    function values() {
      var data = new FormData(form);
      return {
        need: data.get("need"),
        work_mode: data.get("work_mode"),
        volume: data.get("volume"),
        model: data.get("model"),
        budget: data.get("budget"),
        extra: cleanExtra(data.get("extra")),
      };
    }

    function buildQuery(answers, simplified) {
      var parts = simplified
        ? [QUERY.need[answers.need], QUERY.model[answers.model], answers.extra]
        : [
        QUERY.need[answers.need],
        QUERY.workMode[answers.work_mode],
        QUERY.volume[answers.volume],
        QUERY.model[answers.model],
        answers.extra,
      ];
      return parts.filter(Boolean).join(", ");
    }

    function searchUrl(answers) {
      var query = [QUERY.need[answers.need], QUERY.model[answers.model], answers.extra].filter(Boolean).join(" ");
      return "/search?q=" + encodeURIComponent(query) + "&type=product";
    }

    function catalogFilters(answers) {
      var budget = BUDGET[answers.budget] || BUDGET.flexible;
      var filters = { available: true };
      if (budget.min !== null || budget.max !== null) {
        filters.price = {};
        if (budget.min !== null) filters.price.min = budget.min;
        if (budget.max !== null) filters.price.max = budget.max;
      }
      return filters;
    }

    function callCatalog(answers, simplified) {
      var profile = secureProfileUrl(root.getAttribute("data-profile-url"));
      var endpoint = root.getAttribute("data-endpoint") || "/api/ucp/mcp";
      if (!profile) return Promise.reject(new Error("catalog_profile_missing"));
      return fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/event-stream",
        },
        body: JSON.stringify({
          jsonrpc: "2.0",
          method: "tools/call",
          id: Date.now(),
          params: {
            name: "search_catalog",
            arguments: {
              meta: { "ucp-agent": { profile: profile } },
              catalog: {
                query: buildQuery(answers, simplified),
                context: {
                  address_country: "RO",
                  language: "ro",
                  currency: "RON",
                  intent: "shopping",
                },
                filters: catalogFilters(answers),
                pagination: { limit: 24 },
              },
            },
          },
        }),
      }).then(function (response) {
        if (!response.ok) throw new Error("catalog_http_" + response.status);
        return response.json();
      }).then(function (data) {
        if (data.error) throw new Error("catalog_rpc_error");
        var result = data.result || {};
        if (result.isError) throw new Error("catalog_tool_error");
        var products = result.structuredContent && result.structuredContent.products;
        if (!Array.isArray(products) && Array.isArray(result.content)) {
          result.content.some(function (block) {
            if (!block || block.type !== "text" || !block.text) return false;
            try {
              var parsed = JSON.parse(block.text);
              products = parsed.products || (parsed.catalog && parsed.catalog.products);
              return Array.isArray(products);
            } catch (error) {
              return false;
            }
          });
        }
        if (!Array.isArray(products)) throw new Error("catalog_invalid_response");
        return products;
      });
    }

    function renderResult(item, index) {
      var product = item.product;
      var card = element("article", "citera-assist__result-card");
      var media = element("div", "citera-assist__result-media");
      var rank = element("span", "citera-assist__result-rank", "#" + (index + 1));
      var imageData = (product.media || [])[0] || (item.variant.media || [])[0];
      if (imageData && imageData.url) {
        var image = document.createElement("img");
        image.src = imageData.url;
        image.alt = product.title || "Produs Cusut-Surfilat.ro";
        image.loading = "lazy";
        image.decoding = "async";
        media.appendChild(image);
      }
      media.appendChild(rank);

      var body = element("div", "citera-assist__result-body");
      body.appendChild(element("h4", "", product.title));

      var price = element("p", "citera-assist__price");
      var currency = (product.price_range && product.price_range.min && product.price_range.min.currency) || "RON";
      price.appendChild(document.createTextNode(money(item.price, currency)));
      var listPrice = amount(product.list_price_range && product.list_price_range.min);
      if (listPrice && listPrice > item.price) price.appendChild(element("s", "", money(listPrice, currency)));
      body.appendChild(price);

      var reasons = element("ul", "citera-assist__reasons");
      item.reasons.forEach(function (reason) {
        reasons.appendChild(element("li", "", reason));
      });
      body.appendChild(reasons);

      var actions = element("div", "citera-assist__result-actions");
      var addForm = document.createElement("form");
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      addForm.method = "post";
      addForm.action = shopRoot + "cart/add";
      addForm.setAttribute("data-cart-form", "");
      addForm.setAttribute("data-assist-add", "");
      addForm.setAttribute("data-product-id", product.id || "");
      addForm.setAttribute("data-product-name", product.title || "");
      addForm.setAttribute("data-position", String(index + 1));
      addForm.setAttribute("data-value", String(item.price));
      addForm.setAttribute("data-currency", currency);
      appendHidden(addForm, "id", String(item.variant.id || "").split("/").pop());
      appendHidden(addForm, "quantity", "1");
      appendHidden(addForm, "properties[_Citera Assist]", "Recomandare");
      appendHidden(addForm, "properties[_Citera Assist sesiune]", sessionId);
      var addButton = element("button", "button", "Adaugă în coș");
      addButton.type = "submit";
      addForm.appendChild(addButton);
      actions.appendChild(addForm);

      var productLink = element("a", "button button--secondary citera-assist__product-link", "Vezi produsul");
      productLink.href = product.url;
      productLink.setAttribute("data-assist-product-link", "");
      productLink.setAttribute("data-product-id", product.id || "");
      productLink.setAttribute("data-product-name", product.title || "");
      productLink.setAttribute("data-position", String(index + 1));
      actions.appendChild(productLink);
      body.appendChild(actions);

      card.appendChild(media);
      card.appendChild(body);
      return card;
    }

    function showResults(items, answers, rawCount) {
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = true;
      empty.hidden = true;
      results.hidden = false;
      if (panel) panel.scrollTop = 0;
      resultGrid.replaceChildren();
      resultsTitle.textContent = items.length === 1 ? "Am găsit o potrivire clară" : "Am găsit " + items.length + " opțiuni potrivite";
      items.forEach(function (item, index) {
        resultGrid.appendChild(renderResult(item, index));
      });
      track("citera_assist_search_completed", {
        assist_session_id: sessionId,
        result_count: items.length,
        catalog_result_count: rawCount,
        search_source: "shopify_storefront_catalog_ucp",
        need: answers.need,
        budget: answers.budget,
      });
    }

    function showEmpty(answers, reason) {
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = true;
      results.hidden = true;
      empty.hidden = false;
      if (panel) panel.scrollTop = 0;
      standardSearch.href = searchUrl(answers);
      if (reason === "catalog_error") {
        emptyCopy.textContent = "Catalogul inteligent nu a răspuns acum. Poți încerca din nou, folosi căutarea standard sau discuta cu un consultant.";
      } else {
        emptyCopy.textContent = "Niciun produs nu confirmă toate condițiile selectate. Nu vrem să-ți recomandăm ceva nepotrivit.";
      }
      track(reason === "catalog_error" ? "citera_assist_error" : "citera_assist_no_results", {
        assist_session_id: sessionId,
        error_type: reason === "catalog_error" ? "catalog_unavailable" : undefined,
        need: answers.need,
        budget: answers.budget,
      });
    }

    function resetToAnswers() {
      results.hidden = true;
      empty.hidden = true;
      loading.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      currentStep = 0;
      if (panel) panel.scrollTop = 0;
      updateStep();
      track("citera_assist_answers_reopened", { assist_session_id: sessionId });
    }

    openButton.addEventListener("click", openDialog);
    closeButton.addEventListener("click", closeDialog);
    dialog.addEventListener("close", function () {
      document.documentElement.style.overflow = "";
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });

    form.addEventListener("change", function (event) {
      if (event.target && event.target.name === "need") applyBranch();
      nextButton.disabled = !selectedOnStep(currentStep);
      submitButton.disabled = !selectedOnStep(currentStep);
    });

    if (extraInput) {
      extraInput.addEventListener("input", function () {
        extraInput.setCustomValidity("");
      });
    }

    nextButton.addEventListener("click", function () {
      if (!selectedOnStep(currentStep)) return;
      var field = steps[currentStep].querySelector("input[type='radio']:checked");
      track("citera_assist_step_completed", {
        assist_session_id: sessionId,
        step_number: currentStep + 1,
        step_name: steps[currentStep].getAttribute("data-step-name"),
        selected_option: field && field.value,
      });
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      updateStep();
    });

    backButton.addEventListener("click", function () {
      currentStep = Math.max(0, currentStep - 1);
      updateStep();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!selectedOnStep(currentStep)) return;
      var answers = values();
      if ((answers.volume === "code_exact" || answers.volume === "model_exact") && !answers.extra) {
        extraInput.setCustomValidity("Introdu codul piesei sau modelul complet pentru a verifica o potrivire exactă.");
        extraInput.reportValidity();
        extraInput.focus();
        return;
      }
      var field = steps[currentStep].querySelector("input[type='radio']:checked");
      track("citera_assist_step_completed", {
        assist_session_id: sessionId,
        step_number: currentStep + 1,
        step_name: steps[currentStep].getAttribute("data-step-name"),
        selected_option: field && field.value,
      });
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      track("citera_assist_search_started", {
        assist_session_id: sessionId,
        need: answers.need,
        work_mode: answers.work_mode,
        volume: answers.volume,
        model: answers.model,
        budget: answers.budget,
        has_extra_condition: Boolean(answers.extra),
      });
      function rankProducts(products) {
        return products
          .map(function (product) {
            return assessProduct(product, answers);
          })
          .filter(Boolean)
          .sort(function (a, b) {
            return b.score - a.score || a.price - b.price;
          });
      }

      callCatalog(answers, false)
        .then(function (products) {
          var items = rankProducts(products);
          var max = Math.max(1, Math.min(3, Number(root.getAttribute("data-max-results")) || 3));
          if (items.length) {
            showResults(items.slice(0, max), answers, products.length);
            return null;
          }
          return callCatalog(answers, true).then(function (fallbackProducts) {
            var fallbackItems = rankProducts(fallbackProducts);
            track("citera_assist_search_simplified", {
              assist_session_id: sessionId,
              need: answers.need,
              result_count: fallbackItems.length,
            });
            if (!fallbackItems.length) showEmpty(answers, "no_exact_match");
            else showResults(fallbackItems.slice(0, max), answers, fallbackProducts.length);
          });
        })
        .catch(function () {
          showEmpty(answers, "catalog_error");
        });
    });

    root.addEventListener("click", function (event) {
      var restart = event.target.closest("[data-assist-restart]");
      if (restart) {
        resetToAnswers();
        return;
      }
      var contact = event.target.closest("[data-assist-contact]");
      if (contact) {
        track("citera_assist_contact_clicked", { assist_session_id: sessionId });
        return;
      }
      var link = event.target.closest("[data-assist-product-link]");
      if (link) {
        markCartAssisted(sessionId);
        track("citera_assist_recommendation_clicked", {
          assist_session_id: sessionId,
          product_id: link.getAttribute("data-product-id"),
          product_name: link.getAttribute("data-product-name"),
          position: Number(link.getAttribute("data-position")),
          destination: "product_page",
        });
      }
    });

    root.addEventListener("submit", function (event) {
      var addForm = event.target.closest("[data-assist-add]");
      if (!addForm) return;
      markCartAssisted(sessionId);
      track("citera_assist_add_to_cart", {
        assist_session_id: sessionId,
        product_id: addForm.getAttribute("data-product-id"),
        product_name: addForm.getAttribute("data-product-name"),
        position: Number(addForm.getAttribute("data-position")),
        value: Number(addForm.getAttribute("data-value")) / 100,
        currency: addForm.getAttribute("data-currency") || "RON",
      });
    });

    updateStep();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-citera-assist]").forEach(init);
  }

  document.addEventListener("click", function (event) {
    var externalTrigger = event.target.closest("[data-assist-external-open]");
    if (!externalTrigger) return;
    var internalTrigger = document.querySelector("[data-citera-assist] [data-assist-open]");
    if (!internalTrigger) return;
    event.preventDefault();
    internalTrigger.setAttribute(
      "data-assist-placement",
      externalTrigger.getAttribute("data-assist-placement") || "homepage_hero",
    );
    ["data-assist-goal", "data-assist-product-id", "data-assist-product-handle"].forEach(function (attribute) {
      var value = externalTrigger.getAttribute(attribute);
      if (value) internalTrigger.setAttribute(attribute, value);
      else internalTrigger.removeAttribute(attribute);
    });
    var sourceDialog = externalTrigger.closest("dialog[open]");
    if (sourceDialog && typeof sourceDialog.close === "function") {
      sourceDialog.close();
      window.requestAnimationFrame(function () {
        internalTrigger.click();
      });
      return;
    }
    internalTrigger.click();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
